import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading1, Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import {
  StyledContainer,
  StyledContent,
  StyledCTA,
  StyledHero
} from './ResistanceHero.styled';

type ResistanceHeroProps = {
  onRiskClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onRewardsClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

const ResistanceHero: React.FC<ResistanceHeroProps> = ({
  onRewardsClick,
  onRiskClick
}) => {
  const { t } = useI18n('resistanceLanding');
  const { locale } = useRouter();

  return (
    <StyledHero>
      <StyledContainer>
        <StyledContent>
          <Heading1>{t('hero.title')}</Heading1>

          <Heading2>{t('hero.intro')}</Heading2>

          <p>{t('hero.p1')}</p>

          <Heading2 editorial>{t('hero.h2')}</Heading2>

          <p>{t('hero.p2')}</p>

          <p
            dangerouslySetInnerHTML={{
              __html: t('hero.p3')
            }}
          />

          <p>
            <Trans
              ns={'resistanceLanding'}
              i18nKey={'hero.p4'}
              components={{
                risk: <a href="#" onClick={onRiskClick} />
              }}
            />
          </p>
          <p>
            <Trans
              ns={'resistanceLanding'}
              i18nKey={'hero.p5'}
              components={{
                rewards: <a href="#" onClick={onRewardsClick} />
              }}
            />
          </p>

          <StyledCTA>
            <ButtonLink
              href={`${getAppUrl(APP_URLS.join, locale)}?resistance=true`}
              variant="secondary"
              sizes="lg"
            >
              <FontAwesomeIcon icon={faSignInAlt} />

              <span>{t('hero.cta')}</span>
            </ButtonLink>

            <p>
              <span>{t('hero.already')}</span>{' '}
              <a href={`${getAppUrl(APP_URLS.login, locale)}?resistance=true`}>
                {t('hero.signIn')}
              </a>
            </p>
          </StyledCTA>
        </StyledContent>
      </StyledContainer>
    </StyledHero>
  );
};

export default ResistanceHero;
